import { configAxiosMagicLink } from '@/utils/api-instance';

export const getMagicLinkToken = async url => {
    const api = configAxiosMagicLink();
    const { data } = await api.get(url);
    return data;
};
